import React from 'react'
import { Button, Form, Icon } from 'semantic-ui-react'
import { Brand } from '../../redux/types/products'
import { BrandSearch } from '../BrandSearch/BrandSearch'
import { useSelector } from 'react-redux'
import { AppState } from '../../redux/store'

interface OptionalInputProps {
  isEditing: boolean
  onClick: () => void
  onChange: (x: string, y: string) => void
  inputName: string
  value: string | undefined
}

const OptionalInput = (props: OptionalInputProps) => {
  const { inputName, isEditing, onClick, onChange, value } = props
  const source = useSelector((state: AppState) => state.products.brands)
  return (
    <div style={{ marginTop: '20px' }}>
      <Button
        color="teal"
        icon
        onClick={() => onClick()}
        size="huge"
        style={{
          marginRight: 50,
          opacity: isEditing ? '1' : '.5',
        }}
      >
        <Icon name={isEditing ? 'cancel' : 'pencil'} />
        {isEditing ? 'Cancel edit ' : `Edit ${inputName}`}
      </Button>
      <div
        style={{
          display: isEditing ? '' : 'none',
          width: '50%',
        }}
      >
        <BrandSearch
          as={Form.Field}
          placeholder="Search brands.."
          name="optional-bulk-editor-brand"
          onSelect={(result: Brand | null) => {
            if (result) {
              onChange(result.id.toString(), result.name)
            } else {
              onChange('', '')
            }
          }}
          source={source}
          currentBrandId={value}
        />
      </div>
    </div>
  )
}

export default OptionalInput
